module.exports = {"id":"202154","name":"Fabian Bordagaray","rating":"71","photo":"./data/images/photos/4/202154.png","club":{"name":"Fl. Varela","logo":"./data/images/clubs/Fl.Varela.png"},"positions":["BU","AD","MD","MG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianBordagaray0.json
// module id = 1324
// module chunks = 0